
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/react.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-intermediate-react-demo-react-basic","docs-tutorial-intermediate-react-demo-react-update","docs-tutorial-intermediate-react-demo-react-portal"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/intermediate/react.zh.md?type=demo')
};